import { defineComponent as _defineComponent } from 'vue'
import { random } from 'lodash'
import { computed, onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartSkeleton',
  props: {
    type: { default: 'bar' },
    size: { default: 20 },
    scale: { default: 2 },
    itemWidth: { default: 10 },
    width: { default: '100%' }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props
const animate = ref(true)
const scalar = ref(1)
const sizes = computed(() => new Array(props.size).fill(1).map(n => Math.floor(Math.floor(n*(Math.random()*100)) * scalar.value) ))

function randomizeScalarLoop () {
  if (!animate.value) return
  setTimeout(() => {
    scalar.value = Math.random()
    randomizeScalarLoop()
  }, 450)
}

onMounted(() => {
  randomizeScalarLoop()
})
// const itemGap = computed(() => typeof props.width === 'number' ? (props.itemWidth * props.size) : )

const __returned__ = { props, animate, scalar, sizes, randomizeScalarLoop, get random() { return random }, computed, onMounted, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})